const formatTime = (v) => `0${v}`.substr(-2, 2);
const getPossibleDays = (year, month, day) => {
    if (day === '*') {
        const daysInMonth = new Date(Number(year), Number(month), 0).getDate();
        const result = [];
        for (let i = 1; i <= daysInMonth; i++) {
            result.push(formatTime(i));
        }
        return result;
    }
    return day.split(',').map((d) => formatTime(d));
};
export function parseWildcardDates(date, currentDate) {
    const [year, month, day] = date.split('-');
    let possibleYears;
    if (year === '*') {
        const currentYear = currentDate.getFullYear();
        possibleYears = [currentYear.toString(), (currentYear + 1).toString(), (currentYear + 2).toString()];
    }
    else {
        possibleYears = year.split(',');
    }
    let possibleMonths;
    if (month === '*') {
        possibleMonths = [];
        for (let i = 1; i <= 12; i++) {
            possibleMonths.push(formatTime(i));
        }
    }
    else {
        possibleMonths = month.split(',').map((m) => formatTime(m));
    }
    const monthsYearsCombo = [];
    for (const year of possibleYears) {
        for (const month of possibleMonths) {
            monthsYearsCombo.push({ year, month });
        }
    }
    const result = [];
    for (const { year, month } of monthsYearsCombo) {
        const possibleDays = getPossibleDays(year, month, day);
        for (const day of possibleDays) {
            result.push(`${year}-${month}-${day}`);
        }
    }
    return result;
}
export const getDates = (db, de) => {
    const difference = new Date(de).getTime() - new Date(db).getTime();
    const numberOfDays = Math.ceil(difference / (1000 * 3600 * 24));
    if (numberOfDays < 0) {
        return [];
    }
    const curDate = new Date(db);
    return Array(numberOfDays)
        .fill(db)
        .reduce((acc) => {
        const nextDate = new Date(curDate.setDate(curDate.getDate() + 1)).toISOString().split('T')[0];
        return [...acc, nextDate];
    }, [db]);
};
